window.addEventListener('DOMContentLoaded', () => {

    const animArray = [
        '.animSquareSlideInFromLeft',
        '.animWavyDrop',
        '.animWavyRise',
        '.animPopOut',
        '.animTypeWriter',
        '.animLineSwipe',
        '.animGateMark',
        '.animDashOneByOne',
        '.animBorderRoundTrail',
        '.animBorderSplitTrail',
        '.animLineCurtain',
        '.animFlipCascade',
        '.animClockReveal',
        '.animHalfBackgroundRotate',
        '.animBlurZoomIn',
        '.animDoubleLineSlideIn',
        '.animAccentUnderlineGrow1',
        '.animAccentUnderlineGrow2',
        '.animAccentUnderlineGrow3',
        '.animAccentUnderlineGrow4',
        '.animAccentUnderlineGrow5',
        '.animAccentUnderlineGrow6',
        '.animAccentUnderlineGrow7',
        '.animAccentUnderlineGrow8',
    ];

    animArray.forEach(animItem => {
        const animatedElms = document.querySelectorAll(animItem);
        if(animatedElms.length > 0){
            animatedElms.forEach(elm => {
                const observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if(entry.isIntersecting) {
                            elm.classList.add('visible');
                            observer.unobserve(entry.target);
                            if(animItem == '.animTypeWriter') animTypeWriter(elm);
                        }
                    })
                });
                observer.observe(elm);
            });
        }
    });

    function splitLetters(node, duration) {
        let nodeHight = node.offsetHeight;
      
        let content = node.innerHTML;
        node.innerHTML = '';
        let letters = [];
        for (var i = 0; i < content.length; i++) {
            let letter = document.createElement('span');
            letter.className = 'tteLetter';
            letter.innerHTML = content.charAt(i) != ' '?content.charAt(i):'&nbsp;';
            if(duration)
                letter.style.setProperty(duration, i);
            node.appendChild(letter);
            letters.push(letter);
        }
  
        node.style.height = nodeHight + 'px';
    }
    
    function animWavyDrop() {

        let animWavyDropNodes = document.querySelectorAll('.animWavyDrop');
        
        (animWavyDropNodes || []).forEach(animWavyDropNode => {
            splitLetters(animWavyDropNode, '--animWavyDropDuration');
        });
             
    }
      
    animWavyDrop();

    function animWavyRise() {

        let animWavyRiseNodes = document.querySelectorAll('.animWavyRise');
        
        (animWavyRiseNodes || []).forEach(animWavyRiseNode => {
            splitLetters(animWavyRiseNode, '--animWavyRiseDuration');
        });
        
    }

    animWavyRise();

    function animDashOneByOne () {
        let animDashOneByOneNodes = document.querySelectorAll('.animDashOneByOne');

        (animDashOneByOneNodes || []).forEach(animDashOneByOneNode => {
            splitLetters(animDashOneByOneNode, '--animDashOneByOneNum')
        });
    }

    animDashOneByOne();

    function animPopOut() {
	
        let animPopOutNodes = document.querySelectorAll('.animPopOut');
        
        (animPopOutNodes || []).forEach(animPopOutNode => {
            splitLetters(animPopOutNode, '');
        });
        
    }    

    animPopOut();

    function animTypeWriter(node) {
        const fullText = node.textContent;
        node.textContent = '';

        let i = 0;
        const cursor = document.createElement('span');
        cursor.textContent = '|';
        cursor.className = 'animTypeWriter--cursor';
        node.appendChild(cursor);

        function type() {
            if(i < fullText.length) {
                cursor.before(fullText[i]);
                i++
                setTimeout(type, 200);
            } else {
                cursor.remove();
            }
        }

        type();
    }

    function animBorderRoundTrail () {
        let animBorderRoundTrailNodes = document.querySelectorAll('.animBorderRoundTrail');

        (animBorderRoundTrailNodes || []).forEach(animBorderRoundTrailNode => {
            let contentNode = animBorderRoundTrailNode.querySelector('.animBorderRoundTrail__content');
            animBorderRoundTrailNode.style.setProperty('--num',contentNode.innerHTML.length);
        });
    }

    animBorderRoundTrail();

    function animFlipCascade () {
        let animFlipCascadeNodes = document.querySelectorAll('.animFlipCascade');
        
        (animFlipCascadeNodes || []).forEach(animFlipCascadeNode => {
            splitLetters(animFlipCascadeNode, '--num');
        });
    }
    animFlipCascade();

    function animBlurZoomIn () {
        let animBlurZoomInNodes = document.querySelectorAll('.animBlurZoomIn');
        
        (animBlurZoomInNodes || []).forEach(animBlurZoomInNode => {
            splitLetters(animBlurZoomInNode, '--num');
        });
    }
    animBlurZoomIn();
});

